import { motion } from "framer-motion";
import { ChevronLeft, Clock, ShieldCheck, FileText, Instagram } from "lucide-react";
import { Kicker, Btn, AMBER, MUTED, PANEL, LINE } from "./SemaforoUi";

export function Intro({ onStart }) {
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }} data-testid="semaforo-intro">
      <Kicker>Il vostro conto · 5 domande</Kicker>
      <h1 className="font-display font-black text-4xl sm:text-5xl leading-[1.02] tracking-tight" data-testid="semaforo-intro-title">
        Se domani si ferma uno stipendio, quanto reggete?
      </h1>
      <p className="mt-5 text-base sm:text-lg leading-relaxed" style={{ color: MUTED }}>
        È il conto che nessuno vi fa. <span className="text-white font-semibold">Cinque domande, un minuto, nessuna cifra precisa.</span>
        {" "}Alla fine un colore — rosso, giallo o verde — e quanti mesi di ossigeno avete davvero.
      </p>
      <div className="mt-7 grid gap-2.5 text-sm" style={{ color: MUTED }}>
        {[[Clock, "Un minuto, 5 domande a fasce: niente numeri esatti da cercare"],
          [ShieldCheck, "Il colore lo vedete subito, senza lasciare nulla"],
          [FileText, "Poi, se volete, il Piano Ossigeno: le 3 mosse e i tre conti con le vostre cifre"]].map(([Icon, t]) => (
          <div key={t} className="flex items-start gap-3 rounded-lg px-4 py-3" style={{ background: PANEL, border: `1px solid ${LINE}` }}>
            <Icon size={17} className="shrink-0 mt-0.5" style={{ color: AMBER }} /> <span>{t}</span>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <Btn onClick={onStart} testid="semaforo-start">Inizia il test</Btn>
        <p className="mt-3 text-center text-xs" style={{ color: "#64748B" }}>Gratis · dati ISTAT e Banca d'Italia · niente da comprare</p>
      </div>
      <p className="mt-10 text-sm leading-relaxed" style={{ color: MUTED }} data-testid="semaforo-intro-bio">
        Sono Massimiliano Pulla, marito e papà di Leo. Non sono un economista: sono uno che fa i conti a casa come voi, e da un anno li fa a voce alta,
        ogni giorno, su Instagram. Figli, stipendi, tasse. Se pensate che sia colpa vostra, questo test vi farà cambiare idea.
      </p>
      <a href="https://www.instagram.com/massimilianopulla/" target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: AMBER }} data-testid="semaforo-follow-intro">
        <Instagram size={15} /> @massimilianopulla
      </a>
    </motion.div>
  );
}

export function Quiz({ domande, index, answers, onAnswer, onBack }) {
  const q = domande[index];
  const total = domande.length;
  return (
    <div data-testid="semaforo-quiz">
      <div className="flex items-center justify-between mb-3">
        <button onClick={onBack} className="inline-flex items-center gap-1 text-sm" style={{ color: MUTED }} data-testid="semaforo-back">
          <ChevronLeft size={16} /> Indietro
        </button>
        <span className="text-xs uppercase tracking-[0.2em]" style={{ color: AMBER }} data-testid="semaforo-progress">Domanda {index + 1} di {total}</span>
      </div>
      <div className="h-1.5 rounded-full overflow-hidden mb-8" style={{ background: PANEL }}>
        <motion.div className="h-full" style={{ background: AMBER }} initial={false} animate={{ width: `${((index + 1) / total) * 100}%` }} transition={{ duration: 0.35 }} />
      </div>
      <motion.div key={q.key} initial={{ opacity: 0, x: 24 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3 }}>
        <h2 className="font-display font-bold text-2xl sm:text-3xl leading-tight" data-testid={`semaforo-q-${q.key}`}>{q.titolo}</h2>
        <p className="mt-2 text-sm sm:text-base" style={{ color: MUTED }}>{q.sotto}</p>
        <div className="mt-6 grid gap-3">
          {q.opzioni.map((o) => {
            const sel = answers[q.key] === o.key;
            return (
              <button key={o.key} onClick={() => onAnswer(q.key, o.key)} data-testid={`semaforo-opt-${q.key}-${o.key}`}
                className="w-full text-left rounded-xl px-5 py-4 text-base sm:text-lg font-medium transition-[background-color,border-color,transform] active:scale-[0.99]"
                style={{ background: sel ? "#1F2D4D" : PANEL, border: `1px solid ${sel ? AMBER : LINE}`, color: "#fff" }}>
                {o.label}
              </button>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
}
